import { render, staticRenderFns } from "./ContractsTable.vue?vue&type=template&id=a572f26a"
import script from "./ContractsTable.vue?vue&type=script&lang=js"
export * from "./ContractsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports